import { render, staticRenderFns } from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=template&id=4bb283be&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=style&index=0&id=4bb283be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb283be",
  null
  
)

export default component.exports